import { createUrl } from '@/utils';

const info = createUrl('taxpayers');

const declarationInfo = (tin: string, date: string) =>
  info(`${tin}?period=${date}`);

export const declarationEndpoints = { declarationInfo };
